import React from "react";
import InnerPageLayout from "../components/Layout/InnerPageLayout";
import BreadCrumb from "../components/Breadcrumb/BreadCrumb";
import { Link } from "react-router-dom";
import industriesData from "../data/industriesData";


export function AboutService() {
  return (
    <section className="w-full md:pt-[153px]">
      {industriesData.map((industry) => (
        <div key={industry.id} className={`w-full mx-auto theme-container px-4`}>
          <div className="box-border pt-16 mb-16 md:pb-[153px] grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 lg:gap-12 items-center">
            {/* Content Section */}
            <div className={`flex flex-col justify-center lg:col-span-5 order-2 ${industry.imagePosition === 'left' ? 'lg:order-2' : 'lg:order-1'}`}>
            <h2 className="text-34 sm:text-34 md:text-48 font-semibold text-white mb-8 sm:mb-[50px]  w-full xl:w-full">
              {industry.title}
                </h2>
            
              <p className="mb-6 sm:mb-8 md:mb-10 text-paragraph text-sm sm:text-base">
                {industry.description}
              </p>
              <Link to={industry.link}>
                <div className="home-two-btn-bg group bg-[#4A7DFF] border-[#4A7DFF] py-3 sm:py-[15px] px-6 sm:px-8 inline-flex items-center gap-2 sm:gap-3">
                  <span className="text-sm sm:text-base group-hover:text-[#4A7DFF] text-white transition-all duration-300 font-semibold font-inter relative z-10">
                    Explore More
                  </span>
                  <svg
                    className="relative z-10"
                    width="7"
                    height="12"
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="group-hover:stroke-[#4A7DFF] stroke-white transition-all duration-300"
                      d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </Link>
            </div>
            
            {/* Image Section */}
            <div className={`relative flex flex-col justify-center w-full lg:col-span-7 order-1 ${industry.imagePosition === 'left' ? 'lg:order-1' : 'lg:order-2'}`}>
              <img
                src={industry.image}
                alt={industry.title}
                className="w-full h-auto rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}

export default function Industries() {
  return (
    <InnerPageLayout>
      <BreadCrumb pageTitle="Industries" items={[{ label: "Industries", path: "/industries" }]} />
      <AboutService />
    </InnerPageLayout>
  );
}
